// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 407) return "static/chunks/407.de904bb7c44dc535.js";
	if (chunkId === 966) return "static/chunks/64abf602.c5cb2ff9b4ecb7d3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 914 ? "b9f50566" : chunkId) + "-" + {"379":"e9b78f6cb8a744fb","914":"2899cd60a9ca3431","959":"402757a23fc3b73b"}[chunkId] + ".js";
};